export default __webpack_public_path__ + "static/cheekUnveiled-000f7959e451e41909f88004de4bbe15.svg";